import type { DrawingToolInstance, ChartLayout, ChartPriceRange, DraggingOverride, Point } from "./types";
import { findHorizontalHandle, findVerticalHandle, findTwoPointHandle, findThreePointHandle } from "./drawingToolFinders";

export type HandleHit = {
  cursor: string;
  override: DraggingOverride;
  pointKey?: "point1" | "point2" | "point3";
};

export function resolveHandleHit(
  x: number, y: number,
  instances: DrawingToolInstance[],
  override: DraggingOverride | null,
  layout: ChartLayout,
  range: ChartPriceRange,
  tsToX: (ts: number) => number,
): HandleHit | null {
  const h = findHorizontalHandle(x, y, instances, override, layout, range);
  if (h?.coordinates?.kind === "single-price")
    return { cursor: "ns-resize", override: { kind: "price", id: h.id, price: h.coordinates.price } };

  const v = findVerticalHandle(x, y, instances, override, layout, tsToX);
  if (v?.coordinates?.kind === "single-timestamp")
    return { cursor: "ew-resize", override: { kind: "timestamp", id: v.id, timestamp: v.coordinates.timestamp } };

  const tp = findTwoPointHandle(x, y, instances, override, layout, range, tsToX);
  if (tp?.inst.coordinates?.kind === "two-point") {
    const { point1, point2 } = tp.inst.coordinates;
    return { cursor: "grab", override: { kind: "twoPoint", id: tp.inst.id, point1, point2 }, pointKey: tp.pointKey };
  }

  const tp3 = findThreePointHandle(x, y, instances, override, layout, range, tsToX);
  if (tp3?.inst.coordinates?.kind === "three-point") {
    const { point1, point2, point3 } = tp3.inst.coordinates as { point1: Point; point2: Point; point3: Point };
    return { cursor: "grab", override: { kind: "threePoint", id: tp3.inst.id, point1, point2, point3 }, pointKey: tp3.pointKey };
  }

  return null;
}
